// src/components/etc/VendorForm.jsx
import React, { useState, useEffect } from "react";
import styles from "./VendorForm.module.css";

export default function VendorForm({
  onAdd,
  vendors = [],
  editingVendor,
  onCancelEdit,
  defaultSalaryAccount = false, // ✅ 인건비 흐름의 "거래처 등록" 경로로 들어오면 true
}) {
  const [form, setForm] = useState({
    code: "",
    name: "",
    business_number: "",
    ceo_name: "", // ✅ 추가
    manager: "",
    manager_desc: "",
    phone: "",
    fax_number: "",
    email: "",
    bank_name: "",
    account_number: "",
    is_salary_account: defaultSalaryAccount,
  });

  // ✅ 수정모드일 경우 선택된 거래처 데이터 불러오기
  useEffect(() => {
    if (editingVendor) {
      setForm({
        code: editingVendor.code || "",
        name: editingVendor.name || "",
        business_number: editingVendor.business_number || "",
        ceo_name: editingVendor.ceo_name || "", // ✅ 추가
        manager: editingVendor.manager || "",
        manager_desc: editingVendor.manager_desc || "",
        phone: editingVendor.phone || "",
        fax_number: editingVendor.fax_number || "",
        email: editingVendor.email || "",
        bank_name: editingVendor.bank_name || "",
        account_number: editingVendor.account_number || "",
        is_salary_account: !!editingVendor.is_salary_account,
      });
    } else {
      // 새 등록모드일 경우 초기화
      setForm({
        code: "",
        name: "",
        business_number: "",
        manager: "",
        manager_desc: "",
        phone: "",
        fax_number: "",
        email: "",
        bank_name: "",
        account_number: "",
        is_salary_account: defaultSalaryAccount,
      });
    }
  }, [editingVendor, defaultSalaryAccount]);

  // ✅ 입력값 변경 핸들러
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  // ✅ 저장 버튼 클릭 시 (등록 or 수정)
  const handleSubmit = (e) => {
    e.preventDefault();

    // 기본 검증
    if (!form.name.trim()) {
      alert("거래처명을 입력해주세요.");
      return;
    }
    if (!editingVendor && (!form.code || form.code.length !== 4)) {
      alert("CODE는 반드시 4자리 숫자로 입력해주세요.");
      return;
    }

    // 중복 CODE 확인 (신규 등록일 때만)
    if (!editingVendor) {
      const existingVendor = vendors.find((v) => v.code === form.code);
      if (existingVendor) {
        alert(`CODE ${form.code}는 이미 ${existingVendor.name}으로 등록되어 있습니다.`);
        return;
      }
    }

    // 등록 또는 수정 요청
    onAdd(form);
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <input
        type="text"
        name="code"
        placeholder="CODE (4자리 숫자)"
        value={form.code}
        onChange={handleChange}
        maxLength={4}
        required={!editingVendor} // 수정 모드에서는 CODE 필수 아님
        disabled={!!editingVendor} // 수정 시 CODE 변경 불가
      />
      <input
        type="text"
        name="name"
        placeholder="거래처명"
        value={form.name}
        onChange={handleChange}
        required
      />
      <input
        type="text"
        name="business_number"
        placeholder="사업자등록번호"
        value={form.business_number}
        onChange={handleChange}
      />
      <input
        type="text"
        name="ceo_name"
        placeholder="대표자 이름"
        value={form.ceo_name || ""}
        onChange={handleChange}
      />

      <input
        type="text"
        name="manager"
        placeholder="담당자 이름과 직함 작성"
        value={form.manager}
        onChange={handleChange}
      />
      <input
        type="text"
        name="manager_desc"
        placeholder="설명 (사업내용)"
        value={form.manager_desc}
        onChange={handleChange}
      />
      <input
        type="text"
        name="phone"
        placeholder="전화번호"
        value={form.phone}
        onChange={handleChange}
      />
      <input
        type="text"
        name="fax_number"
        placeholder="팩스번호"
        value={form.fax_number}
        onChange={handleChange}
      />
      <input
        type="email"
        name="email"
        placeholder="이메일 주소"
        value={form.email}
        onChange={handleChange}
      />
      <input
        type="text"
        name="bank_name"
        placeholder="은행명"
        value={form.bank_name}
        onChange={handleChange}
      />
      <input
        type="text"
        name="account_number"
        placeholder="계좌번호"
        value={form.account_number}
        onChange={handleChange}
      />
      <label style={{ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
        <input
          type="checkbox"
          name="is_salary_account"
          checked={!!form.is_salary_account}
          onChange={handleChange}
        />
        급여계좌
      </label>

      <div className={styles.buttonRow}>
        <button type="submit" className={styles.button}>
          {editingVendor ? "수정 완료" : "저장"}
        </button>

        {editingVendor && (
          <button
            type="button"
            onClick={onCancelEdit}
            className={styles.cancelButton}
          >
            취소
          </button>
        )}
      </div>
    </form>
  );
}
